"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setReadNotificationsSaga = exports.checkCPAndSetZones = void 0;
const effects_1 = require("redux-saga/effects");
const reducers_main_reducer_1 = require("@/bit/reducers/reducers.main-reducer");
let getCpZoneModule = null;
function* getCpZoneFetcher() {
    if (!getCpZoneModule) {
        const module = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require("@gcloud-npm/adabyron.geo.get-cp-zone"))));
        getCpZoneModule = module.default;
    }
    return getCpZoneModule;
}
function* setDefaultCase({ reloadNeeded }) {
    // fallará cada vez que no tenga cookie tengo que mirar si tiene un geo persistido para no mandarle el de madrid siempre
    const responseMock = {
        persist: true,
        zone: "ZL",
        businessZones: [
            {
                geographicAreaName: "Madrid",
                businessZoneName: "ZL",
            },
        ],
        cp: "28030",
        defaultValue: false,
        mobile: "undefined",
        x: "",
    };
    yield (0, effects_1.put)(reducers_main_reducer_1.actions.setCpParams(responseMock));
    yield (0, effects_1.put)(reducers_main_reducer_1.actions.setCheckedCPByApi(true));
    yield (0, effects_1.delay)(250);
    yield (0, effects_1.put)(reducers_main_reducer_1.actions.setSCCookie({ reloadNeeded }));
}
function* checkCPAndSetZones({ data }) {
    try {
        const { cp, needBussinesZone, reloadNeeded = false } = data;
        if (cp === "x") {
            yield (0, effects_1.call)(setDefaultCase, { reloadNeeded });
            return;
        }
        const module = yield (0, effects_1.call)(getCpZoneFetcher);
        const lastCP = yield (0, effects_1.select)((state) => state.main.cp);
        const context = yield (0, effects_1.select)((state) => state.main.context);
        const lastMunicipio = yield (0, effects_1.select)((state) => state.main.municipio);
        // need get again bussinessZones, cuando montamos el modal con datos ya persistidos y no tenmoes la lista de municipios    
        if (needBussinesZone) {
            yield (0, effects_1.put)(reducers_main_reducer_1.actions.setCheckedCPByApi(false));
            let response = yield (0, effects_1.call)(module, { cp, context });
            const { businessZones } = response;
            const lastZone = yield (0, effects_1.select)((state) => state.main.zone);
            response = Object.assign(Object.assign({}, data), { cp: lastCP, zone: lastZone, municipio: lastMunicipio, businessZones });
            yield (0, effects_1.put)(reducers_main_reducer_1.actions.setCheckedCPByApi(false));
            yield (0, effects_1.put)(reducers_main_reducer_1.actions.setCpParams(response));
        }
        // regular behaviour
        if (!needBussinesZone && (lastCP !== cp || !lastMunicipio)) {
            yield (0, effects_1.put)(reducers_main_reducer_1.actions.setCheckedCPByApi(false));
            let response = yield (0, effects_1.call)(module, { cp, context });
            let zone = (response && response.zone) || "ZL";
            let municipio = null;
            // getting first result and using its zone
            if (response &&
                response.businessZones &&
                Array.isArray(response.businessZones) &&
                response.businessZones.length > 0) {
                const { businessZoneName } = response.businessZones[0];
                zone = businessZoneName;
                if (zone === "ZM") {
                    zone = "ZL";
                }
                municipio = response.businessZones[0];
            }
            response = Object.assign(Object.assign(Object.assign({}, data), response), { cp: response.postalCode, zone,
                municipio, persist: true });
            delete response.postalCode;
            yield (0, effects_1.put)(reducers_main_reducer_1.actions.setCpParams(response));
            yield (0, effects_1.put)(reducers_main_reducer_1.actions.setCheckedCPByApi(true));
            yield (0, effects_1.delay)(250);
            yield (0, effects_1.put)(reducers_main_reducer_1.actions.setSCCookie({ reloadNeeded }));
        }
    }
    catch (err) {
        yield (0, effects_1.call)(setDefaultCase);
    }
}
exports.checkCPAndSetZones = checkCPAndSetZones;
function* setReadNotificationsSaga({ data }) {
    try {
        yield (0, effects_1.put)(reducers_main_reducer_1.actions.setReadNotificationsSuccess());
    }
    catch (e) {
        console.log(e);
    }
}
exports.setReadNotificationsSaga = setReadNotificationsSaga;
//# sourceMappingURL=index.js.map